// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PFK38Xqe5rndC4gbFKKk {
  align-items: center;
  display: flex;
  height: 50vh;
  justify-content: center;
  width: 100%;
}

/* Loader css come from: https://loading.io/css/ */

.q8mczlCgTy7gLDwhCHZe {
  display: inline-block;
  height: 80px;
  position: relative;
  width: 80px;
}

.q8mczlCgTy7gLDwhCHZe div {
  animation: q8mczlCgTy7gLDwhCHZe 1.2s linear infinite;
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]};
  border-radius: 50%;
  height: 6px;
  position: absolute;
  width: 6px;
}

.q8mczlCgTy7gLDwhCHZe div:nth-child(1) {
  animation-delay: 0s;
  left: 66px;
  top: 37px;
}

.q8mczlCgTy7gLDwhCHZe div:nth-child(2) {
  animation-delay: -0.1s;
  left: 62px;
  top: 22px;
}

.q8mczlCgTy7gLDwhCHZe div:nth-child(3) {
  animation-delay: -0.2s;
  left: 52px;
  top: 11px;
}

.q8mczlCgTy7gLDwhCHZe div:nth-child(4) {
  animation-delay: -0.3s;
  left: 37px;
  top: 7px;
}

.q8mczlCgTy7gLDwhCHZe div:nth-child(5) {
  animation-delay: -0.4s;
  left: 22px;
  top: 11px;
}

.q8mczlCgTy7gLDwhCHZe div:nth-child(6) {
  animation-delay: -0.5s;
  left: 11px;
  top: 22px;
}

.q8mczlCgTy7gLDwhCHZe div:nth-child(7) {
  animation-delay: -0.6s;
  left: 7px;
  top: 37px;
}

.q8mczlCgTy7gLDwhCHZe div:nth-child(8) {
  animation-delay: -0.7s;
  left: 11px;
  top: 52px;
}

.q8mczlCgTy7gLDwhCHZe div:nth-child(9) {
  animation-delay: -0.8s;
  left: 22px;
  top: 62px;
}

.q8mczlCgTy7gLDwhCHZe div:nth-child(10) {
  animation-delay: -0.9s;
  left: 37px;
  top: 66px;
}

.q8mczlCgTy7gLDwhCHZe div:nth-child(11) {
  animation-delay: -1s;
  left: 52px;
  top: 62px;
}

.q8mczlCgTy7gLDwhCHZe div:nth-child(12) {
  animation-delay: -1.1s;
  left: 62px;
  top: 52px;
}

@keyframes q8mczlCgTy7gLDwhCHZe {

  0%,
  20%,
  80%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.5);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/library/Loading/Loading.module.css"],"names":[],"mappings":"AAGA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA,kDAAkD;;AAElD;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oDAAuC;EACvC,wDAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;;AAEA;;EAEE;;;;IAIE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":["@value colors: \"../style/colors.css\";\n@value color-gray from colors;\n\n.loadingContainer {\n  align-items: center;\n  display: flex;\n  height: 50vh;\n  justify-content: center;\n  width: 100%;\n}\n\n/* Loader css come from: https://loading.io/css/ */\n\n.loading {\n  display: inline-block;\n  height: 80px;\n  position: relative;\n  width: 80px;\n}\n\n.loading div {\n  animation: loading 1.2s linear infinite;\n  background: color-gray;\n  border-radius: 50%;\n  height: 6px;\n  position: absolute;\n  width: 6px;\n}\n\n.loading div:nth-child(1) {\n  animation-delay: 0s;\n  left: 66px;\n  top: 37px;\n}\n\n.loading div:nth-child(2) {\n  animation-delay: -0.1s;\n  left: 62px;\n  top: 22px;\n}\n\n.loading div:nth-child(3) {\n  animation-delay: -0.2s;\n  left: 52px;\n  top: 11px;\n}\n\n.loading div:nth-child(4) {\n  animation-delay: -0.3s;\n  left: 37px;\n  top: 7px;\n}\n\n.loading div:nth-child(5) {\n  animation-delay: -0.4s;\n  left: 22px;\n  top: 11px;\n}\n\n.loading div:nth-child(6) {\n  animation-delay: -0.5s;\n  left: 11px;\n  top: 22px;\n}\n\n.loading div:nth-child(7) {\n  animation-delay: -0.6s;\n  left: 7px;\n  top: 37px;\n}\n\n.loading div:nth-child(8) {\n  animation-delay: -0.7s;\n  left: 11px;\n  top: 52px;\n}\n\n.loading div:nth-child(9) {\n  animation-delay: -0.8s;\n  left: 22px;\n  top: 62px;\n}\n\n.loading div:nth-child(10) {\n  animation-delay: -0.9s;\n  left: 37px;\n  top: 66px;\n}\n\n.loading div:nth-child(11) {\n  animation-delay: -1s;\n  left: 52px;\n  top: 62px;\n}\n\n.loading div:nth-child(12) {\n  animation-delay: -1.1s;\n  left: 62px;\n  top: 52px;\n}\n\n@keyframes loading {\n\n  0%,\n  20%,\n  80%,\n  100% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(1.5);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../style/colors.css"`,
	"color-gray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]}`,
	"loadingContainer": `PFK38Xqe5rndC4gbFKKk`,
	"loading": `q8mczlCgTy7gLDwhCHZe`
};
export default ___CSS_LOADER_EXPORT___;
